import axios from 'axios';
import {handleSuccess, handleError} from './helpers';
import {env, getCookie, deleteCookie} from '../utils/helpers';
import {KEY_AUTHENTICATED, KEY_AUTHENTICATION_TOKEN} from '../utils/constants';

const TrackerService = axios.create({
  baseURL: `${env(
    'REACT_APP_BOOKME_API_BASE_URL',
    'https://tracker-api.tpsportal.co.nz'
  )}/api/`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
  },
  withCredentials: true,
});

TrackerService.interceptors.response.use(handleSuccess, handleError);

TrackerService.interceptors.request.use(
  config => {
    const auth = getCookie(KEY_AUTHENTICATED);
    const token = getCookie(KEY_AUTHENTICATION_TOKEN);
    if (token && auth === 'true') {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    } else if (!token && auth === 'true') {
      deleteCookie(KEY_AUTHENTICATED);
      // eslint-disable-next-line
      window.location.href = '/';
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default TrackerService;
